import {useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'

export const HD_PREPARATION_DELAY_MS = 15 * 60 * 1000

export const preparationStart = (value) => {
  if (typeof value !== 'string' || !value.trim()) return null
  // Legacy backend timestamps are UTC but omit their zone.
  const parsed = Date.parse(/[zZ]$|[+-]\d{2}:?\d{2}$/.test(value) ? value : `${value}Z`)
  return Number.isFinite(parsed) ? parsed : null
}

const PlanetHdPreparationStatus = ({preparation, localStartedAt, onRefresh, refreshing}) => {
  const {t} = useTranslation()
  const [now, setNow] = useState(Date.now)
  useEffect(() => {
    const timer = window.setInterval(() => setNow(Date.now()), 1000)
    return () => window.clearInterval(timer)
  }, [])
  const started = preparationStart(preparation?.started_at) ?? localStartedAt ?? null
  const elapsed = started == null ? null : Math.max(0, now - started)
  const minutes = elapsed == null ? null : Math.floor(elapsed / 60000)
  const state = preparation?.provider_state
  const status = state === 'queued'
    ? t('images:hd_dates.preparation_queued', {defaultValue: 'Planet tiene la imagen en lista de espera.'})
    : state === 'running'
      ? t('images:hd_dates.preparation_running', {defaultValue: 'Planet está procesando y entregando la imagen.'})
      : ['paused', 'suspended'].includes(state)
        ? t('images:hd_dates.preparation_paused', {defaultValue: 'La preparación está pausada en Planet.'})
        : t('images:hd_dates.preparing_wait')
  const checked = preparationStart(preparation?.checked_at)
  const lookupError = Boolean(preparation?.last_check_error)

  return <div className="view-land-hd-calendar__status">
    <div role="status">
      {status}
      {minutes != null && <div>{minutes < 1
        ? t('images:hd_dates.preparation_under_minute', {defaultValue: 'Tiempo de espera: menos de un minuto.'})
        : t('images:hd_dates.preparation_minutes', {minutes, defaultValue: `Tiempo de espera: ${minutes} min.`})}</div>}
      {checked != null && <small>{t('images:hd_dates.preparation_checked', {
        time: new Date(checked).toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'}),
        defaultValue: `Última consulta: ${new Date(checked).toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'})}.`,
      })}</small>}
    </div>
    {elapsed != null && elapsed >= HD_PREPARATION_DELAY_MS && <div role="status">{t('images:hd_dates.preparation_delayed', {
      defaultValue: 'La preparación está demorando. Esto no significa que haya fallado. Podés salir de esta pantalla y volver a consultar; no hace falta solicitar la imagen otra vez.',
    })}</div>}
    {lookupError && <div role="alert">{t('images:hd_dates.preparation_lookup_error', {
      defaultValue: 'No se pudo consultar el estado más reciente. La solicitud sigue pendiente; no se generará otra orden.',
    })}</div>}
    <button type="button" className="btn btn-sm btn-light mt-2" onClick={onRefresh} disabled={refreshing}>
      {t('images:hd_dates.check_status', {defaultValue: 'Consultar estado'})}
    </button>
  </div>
}

export default PlanetHdPreparationStatus
